import AppRolesIndex from "./roles.vue";
import AppRolesList from "./roles-list/roles-list.vue";
import AppRolesItem from "./roles-item/roles-item.vue";

const rolesRoutes = [
  {
    path: "roles",
    component: AppRolesIndex,
    meta: {
      auth: {
        roles: "role.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "roles.index",
        component: AppRolesList,
        meta: {
          auth: {
            roles: "role.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "roles.create",
        component: AppRolesItem,
        meta: {
          auth: {
            roles: "role.create",
            redirect: { name: "roles.index" }
          }
        }
      },
      {
        path: ":id",
        name: "roles.edit",
        component: AppRolesItem,
        meta: {
          auth: {
            roles: "role.update",
            redirect: { name: "roles.index" }
          }
        }
      }
    ]
  }
];

export default rolesRoutes;
